import { decodeEntities } from "~/utils/text";

// Normalizes text on both sides of the match (indexed fields + user query) so
// they compare on equal footing:
//   - Non-breaking hyphen (U+2011) and soft hyphen (U+00AD) → ASCII hyphen, so
//     the scorer's word-split regex and user-typed queries align. Entity
//     decoding handles `&#8209;` written in frontmatter.
//   - Diacritics folded (NFD + strip combining marks) so "beëdigd" matches
//     "beedigd" and "café" matches "cafe" — common on a Dutch site where users
//     rarely type the accents.
export function searchNormalize(s: string | undefined | null): string {
  if (!s) return "";
  return decodeEntities(s)
    .replace(/[‑­]/g, "-")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
}
